import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-group";

export const saveOrUpdate = (sr) => {
  const url = API_PATH + "/save-or-update";
  return axios.post(url, sr);
};

export const getServiceGroupById = (serviceGroupId) => {
  const url = API_PATH + "/get-by-id/" + serviceGroupId;
  return axios.get(url);
};

export const deleteServiceGroupById = (srId) => {
  const url = API_PATH + "/mark-delete/" + srId;
  return axios.delete(url);
};

export const pagingServiceGroup = (searchObj) => {
  const url = API_PATH + "/search-by-page";
  return axios.post(url, searchObj);
};

export const exportServiceGroup = (obj) => {
  let url = API_PATH + "/export-excel-report-group-service";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};
